import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import "@arcgis/map-components/components/arcgis-map";
import "@arcgis/map-components/components/arcgis-basemap-gallery";
import "@arcgis/map-components/components/arcgis-expand";
import "@arcgis/map-components/components/arcgis-zoom";

import "@esri/calcite-components/components/calcite-shell-panel";

import ReservationsPanel from "./ReservationsPanel";
import { APP_CONFIG } from '@config/config';
import { useAuthBiogems } from '@cores/security/hooks/useAuthBiogems';

// Import the two primary hook controllers
import { useReservations } from './useReservations';
import useReservationsMap from './useReservationsMap';

import './ReservationsWithMap.css';

const ReservationsWithMap = ({ setMapviewCtxt }) => {
  const navigate = useNavigate();
  const { user } = useAuthBiogems();

  // 1. Business Logic Hook (The Brains)
  const {
    allReservations,
    reservationsObjByCluster,
    selectedReservations,
    selectedClusters,
    error,
    setError,
    recentReservations,
    reservationList,
    handlers,
  } = useReservations();

  // 2. Map Logic Hook (The Map Renderer)
  const {
    onarcgisViewReadyChange,
    mapActions
  } = useReservationsMap(
    allReservations,
    selectedReservations,
    handlers.handleSelection,
    setMapviewCtxt
  );

  useEffect(() => {
    if (!user) {
      navigate('/forbidden');
    }
  }, [navigate, user]);

  return (
    <>
      <calcite-shell-panel
        slot="panel-start"
        position="start"
        display-mode="dock"
        resizable
      >
        <ReservationsPanel
          allReservations={allReservations}
          reservationsByCluster={reservationsObjByCluster}
          selectedReservations={selectedReservations}
          selectedClusters={selectedClusters}
          recentReservations={recentReservations}
          reservationList={reservationList}
          error={error}
          setError={setError}

          handleListItemSelect={handlers.handleSelection}
          handleSearchSelect={handlers.handleSearchSelect}
          handleClusterSelect={handlers.handleClusterSelect}
          onSelectAll={handlers.handleSelectAll}
          onDeselectAll={handlers.handleDeselectAll}
          onContinue={handlers.handleContinue}

          onZoomSelReservations={mapActions.zoomToSelReservations}
          onZoomReservation={mapActions.zoomReservation}
        />
      </calcite-shell-panel>

      <arcgis-map
        basemap="osm"
        zoom={APP_CONFIG.MAPS.Normal.zoom}
        center={APP_CONFIG.MAPS.Normal.center}
        onarcgisViewReadyChange={onarcgisViewReadyChange}
        aria-label="Interactive map showing reservation locations"
      >
        <arcgis-zoom slot="top-right" />

        <arcgis-expand slot="top-right">
          <arcgis-basemap-gallery />
        </arcgis-expand>
      </arcgis-map>
    </>
  );
};

ReservationsWithMap.propTypes = {
  setMapviewCtxt: PropTypes.func,
};

export default ReservationsWithMap;